export default __webpack_public_path__ + "static/media/Yemane_Birhane_CV.57fcac5a.pdf";